import React from "react";
import { Button } from "semantic-ui-react";

import SemanticUiModal from "../../../../../components/modal";
import NewTranslationModalContent from "./new_translation_modal_content";
import { getText } from "../../../../../helpers";

const modalOptions = { className: "new-tanslations-modal", size: "medium" };

export default function NewTranslationModal(props) {
  const { newTranslation, onClose } = props;

  return (
    <SemanticUiModal
      modalOptions={modalOptions}
      header={getText("AI Translation")}
      content={<NewTranslationModalContent newTranslation={newTranslation} onClose={onClose} />}
      actions={
        <Button positive onClick={onClose}>
          {getText("Close")}
        </Button>
      }
      closeModal={onClose}
    />
  );
}



// WEBPACK FOOTER //
// ./src/views/control_library/table/tanslations_modal/new_translation_modal/new_translation_modal.js